import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './MisEventosSponsorPage.css';

function MisEventosSponsorPage() {
  const { userId, logout } = useAuth();
  const [eventos, setEventos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userId) return;

    fetch(`${process.env.REACT_APP_API_URL}/api/sponsor/events/user/${userId}`)
      .then(res => res.json())
      .then(setEventos)
      .catch(err => console.error("Error al cargar eventos:", err));
  }, [userId]);

  const irADetalle = (eventId) => {
    navigate(`/mis-eventos/${eventId}`);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="mis-eventos-container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h2>Mis Eventos Activos</h2>
        <button onClick={handleLogout} style={{
          padding: '8px 15px',
          backgroundColor: '#d9534f',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}>
          Cerrar sesión
        </button>
      </div>

      {eventos.length === 0 ? (
        <p style={{ textAlign: 'center' }}>No tienes eventos activos.</p>
      ) : (
        <div className="eventos-grid">
          {eventos.map(evento => (
            <div className="evento-card" key={evento.id} onClick={() => irADetalle(evento.id)}>
             <img
                src={evento.imageUrl}
                alt={evento.title}
                className="evento-imagen"
                style={{ height: '150px', objectFit: 'contain', width: '100%', background: '#f8f8f8' }}
                />
              <div className="evento-info">
                <h3>{evento.title}</h3>
                <p><strong>Lugar:</strong> {evento.placeName}</p>
                <p><strong>Ciudad:</strong> {evento.placeCity}</p>
                <p><strong>Fecha:</strong> {new Date(evento.date).toLocaleString('es-DO')}</p>
                <p><strong>Visitas:</strong> {evento.visitCount}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MisEventosSponsorPage;
